/* tslint:disable:no-console */
import React, { useCallback, useEffect, useState } from 'react';
import { APP_CONSTANT } from '../../constants';
import { IUserMetricsService } from '../../services/user-metrics';
import PendoTracker, { PendoAttributes } from '../PendoTracker';

export type PendoIntegrationProps = {
  pendoApiKey?: string;
  metricsService?: IUserMetricsService<PendoAttributes>;
};

const defaultProps: PendoIntegrationProps = {
  pendoApiKey: APP_CONSTANT.PENDO_API_KEY
};

export const PendoIntegration = ({
  metricsService,
  pendoApiKey = defaultProps.pendoApiKey
}: PendoIntegrationProps): React.ReactElement => {
  const [trackingData, setTrackingData] = useState<PendoAttributes>();

  const loadTrackingData = useCallback(async () => {
    if (!metricsService) return;
    const pendoData = await metricsService.fetchTrackedAttributes();
    if (pendoData) {
      setTrackingData(pendoData);
    }
  }, [metricsService, setTrackingData]);

  useEffect(() => {
    const fetchAttrs = async () => {
      try {
        await loadTrackingData();
      } catch (err) {
        console.error("Couldn't fetch data for user metrics: ", err); // eslint-disable-line no-console
      }
    };

    fetchAttrs();
  }, [loadTrackingData]);

  return (
    <>
      {trackingData && (
        <PendoTracker
          account={trackingData.account}
          visitor={trackingData.visitor}
          apiKey={pendoApiKey}
          logger={console.debug} // eslint-disable-line no-console
        />
      )}
    </>
  );
};

export default PendoIntegration;
